import { Toaster } from '@cinesend/ui-kit'
import QueryState from './components/query_state'
import { BrowserRouter } from 'react-router-dom'
import Helmet from 'react-helmet'
import { StoreProvider } from './contexts/store'
import { ConfirmDialogProvider } from './contexts/confirm_dialog'
import { RoutesList } from './routes'
import useAuth from './hooks/use_auth'
import useUtilities from './hooks/use_utilities'

function AirlineCycleWrapper() {
  const { user, isLoading: isUserLoading, logOut } = useAuth()

  return (
    <>
      <QueryState isLoading={isUserLoading || logOut.isLoading} loadingClassName='h-screen'>
        <RoutesList isUserLoading={isUserLoading} user={user} logOut={logOut} />
      </QueryState>
      <BrandedHelmet organization={user?.organization} />
      <Toaster closeButton />
    </>
  )
}

function App() {
  // This initializes some API calls that are used frequently.
  useUtilities()

  // this may be necessary if we host the portal on multiple domains and different clients have different logins.
  // const { data: organization, isLoading: isOrganizationLoading } = useQuery({
  //   queryKey: ['/domain'],
  //   refetchOnWindowFocus: false
  // })

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        // v7_relativeSplatPath: true // TODO: refactor in separate task
      }}
    >
      <StoreProvider>
        <ConfirmDialogProvider>
          <AirlineCycleWrapper />
        </ConfirmDialogProvider>
      </StoreProvider>
    </BrowserRouter>
  )
}

function BrandedHelmet({ organization }) {
  if (!organization) return null
  return (
    <Helmet>
      <meta charSet='utf-8' />
      <title>{organization.name}</title>
      {organization.favicon_url ? (
        <link rel='icon' href={organization.favicon_url} />
      ) : (
        <link rel='icon' href={'/public/favicon.png'} />
      )}
    </Helmet>
  )
}

export default App
